<i18n src="@/i18n/components/search/filter.json"></i18n>
<template>
  <div class="filter-contact-shop-name-field">
    <FilterBaseInputText
      v-model="value"
      :prefix="$t('containsPrefix')"
      :suffix="$te('containsSuffix') ? $t('containsSuffix') : ''"
    />
  </div>
</template>

<script lang="ts">
import { Component, Model, Vue } from "vue-property-decorator";
import { FilterContactShopNameCondition } from "@/models/search/filter-node-condition/FilterContactShopNameCondition";

import FilterBaseInputText from "@/components/filter/form/FilterBaseInputText.vue";

@Component({
  components: {
    FilterBaseInputText
  }
})
export default class FilterContactShopNameField extends Vue {
  @Model("input", {
    type: FilterContactShopNameCondition,
    required: true
  })
  condition!: FilterContactShopNameCondition;

  onInput(condition: FilterContactShopNameCondition) {
    this.$emit("input", condition);
  }

  get value(): string {
    return this.condition.shopName;
  }
  set value(value: string) {
    this.onInput(new FilterContactShopNameCondition(value));
  }
}
</script>
<style lang="scss" scoped>
.filter-contact-shopName-field {
  display: flex;
  align-items: center;
}

.select-box {
  margin-right: 7px;
}
</style>
